import { makeStyles } from "@mui/styles";
import {
  Alternatives,
  Parameter,
  ParameterValue,
  SelectionAlternative,
} from "../../common/types/parameters";
import SelectionCard from "./selection-card";
import {
  canHaveCommonSelectionInput,
  getAlternativeSuffix,
  getAsAlternative,
} from "./util";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "stretch",
    padding: "20px 0",
  },
}));

export default function MultiParameterSelectionCards(params: {
  parameters: Parameter[];
  onValidChange?: (selectedValues: ParameterValue[]) => void;
}) {
  const classes = useStyles();

  let alternatives = (params.parameters[0].constraints as Alternatives).map(
    (selectionAlternative) =>
      ({
        id: getSuffix(selectionAlternative, params.parameters[0].id),
        displayName: selectionAlternative.displayName,
      }) as SelectionAlternative
  );
  let selectedAlternativeSuffix = getSuffix(
    getAsAlternative(params.parameters[0].value),
    params.parameters[0].id
  );

  return canHaveCommonSelectionInput(params.parameters) ? (
    <div
      className={classes.container}
      key={`wizard-parameter-${params.parameters.map((parameter) => parameter.id).join("-")}-block`}
    >
      {alternatives.map((alternative) => (
        <SelectionCard
          value={alternative.id}
          title={alternative.displayName}
          selected={alternative.id === selectedAlternativeSuffix}
          onClick={(selectedOptionSuffix: string) => {
            if (params.onValidChange !== undefined) {
              params.onValidChange!(
                params.parameters.map((parameter) => ({
                  id: parameter.id,
                  value: JSON.stringify(
                    (parameter.constraints as Alternatives).find(
                      (alternative) =>
                        alternative.id.endsWith(selectedOptionSuffix)
                    )
                  ),
                }))
              );
            }
          }}
        />
      ))}
    </div>
  ) : null;
}

function getSuffix(
  alternative: SelectionAlternative | undefined,
  prefix: string
): string | undefined {
  return alternative ? getAlternativeSuffix(prefix, alternative) : undefined;
}
